module.exports = __webpack_public_path__ + "static/media/cd.f08c4721.svg";